import type { TAttorneysTransactionsListParams } from 'app/queries/attorneys/attorneysKeys';

export const buildAttorneysTransactionsRequest = (
  organizationId: string,
  params: TAttorneysTransactionsListParams,
) => ({
  organizationId,
  skip: (params.page - 1) * params.pageSize,
  limit: params.pageSize,
  search: params.search,
  from: params.from,
  to: params.to,
  orderBy: params.orderBy,
  orderType: params.orderType,
});
